import React from "react";
import Button from "../global/Button";
import SignUpButton from "../global/SignUpButton";
import { css } from "emotion";
import config from "../../config";
import CMSComponent from "../CMSComponent";
import ColorServices from "../../services/ColorServices";
import { H3 } from "../global/TextComponents";
import { max } from "../../utils/CssUtils";

const consoleUrl = config("CONSOLE_URL");

const wrapper = css({
  backgroundColor: ColorServices.getColor("purpleMid"),
  padding: "72px 0px",
  textAlign: "center",
  h3: {
    color: ColorServices.getColor("white"),
    margin: "0 auto",
    marginBottom: 16,
    maxWidth: 590
  },
  [max(600)]: {
    padding: "40px 14px",
    button: {
      fontSize: "14px !important",
      height: 36
    }
  }
});

const CallToAction = ({ text, buttonText, link, isSignUpButton }) => {
  return (
    <div className={wrapper}>
      <H3>{text}</H3>
      {isSignUpButton ? (
        <SignUpButton size="large" type="secondary" ariaLabel={buttonText}>
          {buttonText}
        </SignUpButton>
      ) : (
        <Button
          size="large"
          type="secondary"
          link={link ? link : consoleUrl}
          ariaLabel={buttonText}
        >
          {buttonText}
        </Button>
      )}
    </div>
  );
};

export default CMSComponent(null, CallToAction, 230);
